<template>
  <base-input :rules="internalRules" :errors="errors">
    <div class="tw-relative tw-z-10">
      <label :class="['tw-absolute tw--top-2 tw-left-2 tw--mt-px tw-inline-block tw-px-1 tw-z-10 tw-bg-white tw-text-xs tw-font-normal', `tw-text-${labelColor}`]" v-if="label">{{
        label
      }}</label>
      <select
        :disabled="disabled"
        :class="[
          'form-select tw-mt-1 tw-block tw-w-full tw-pl-3 tw-pr-10 tw-py-2 tw-text-light tw-border-gray-200 focus:tw-outline-none tw-ring-0 tw-rounded-md tw-transition-all tw-ease-in-out tw-duration-100 tw-font-light tw-bg-white',
          `focus-within:tw-ring-${focusColor} focus-within:tw-border-${focusColor} tw-border-${borderColor}`,
          value === null ? `tw-text-${placeholderColor}` : '',
          `sm:tw-text-${size}`,
        ]"
        @input="$emit('input', $event.target.value)"
        @blur="validate"
        :title="getSelectTitle()"
      >
        <option disabled v-if="placeholder" :value="null" :selected="value === null">{{ placeholder }}</option>

        <optgroup v-for="(optgroup, index) in optgroups" :key="index" :label="optgroup.label">
          <option v-for="option in optgroup.options" :key="option[valueKey]" :value="option[valueKey]" :selected="option[valueKey] === value" :title="option[labelKey]">
            {{ option[labelKey] }}
          </option>
        </optgroup>

        <option v-for="option in options" :key="option[valueKey]" :value="option[valueKey]" :selected="option[valueKey] === value" :title="option[labelKey]">
          {{ option[labelKey] }}
        </option>
      </select>
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    label: String,
    placeholder: String,
    options: Array,
    optgroups: Array,
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    size: {
      type: String,
      default: "sm",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("input", null);
    },

    getSelectTitle() {
      if (this.value === null) return this.placeholder || "";

      // 1. Check options without groups
      const selectedOption = this.options ? this.options.find((o) => o[this.valueKey] === this.value) : null;
      if (selectedOption) {
        return selectedOption[this.labelKey];
      }

      // 2. Check options within groups
      if (this.optgroups) {
        for (const group of this.optgroups) {
          const selectedInGroup = group.options.find((o) => o[this.valueKey] === this.value);
          if (selectedInGroup) {
            return selectedInGroup[this.labelKey];
          }
        }
      }
      return "";
    },
  },
};
</script>
